
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("gieZF", function(module, exports) {
$parcel$export(module.exports, "LanguageSelector", function () { return $16a7d960140cfe88$export$ddd501dda1f62236; });
/* language-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5r4Ts = parcelRequire("5r4Ts");
var $kKAAc = parcelRequire("kKAAc");

var $g1rTV = parcelRequire("g1rTV");

var $FapDU = parcelRequire("FapDU");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $hu7gH = parcelRequire("hu7gH");

var $aKcYL = parcelRequire("aKcYL");
/**
 * Custom React-Select's Control component to allow adding the globe icon.
 */ const $16a7d960140cfe88$var$Control = ({ children: children, ...props })=>{
    // @ts-expect-error this is an old component and simplified typing
    const { isMouseOver: isMouseOver, isDarkTheme: isDarkTheme } = props.selectProps;
    const defaultColor = isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : '#42526e';
    const hoverColor = isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.dark1100') : '#172b4d';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5r4Ts.c).Control, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKcYL.LanguageGlobeIcon), {
                color: isMouseOver ? hoverColor : defaultColor
            }),
            children
        ]
    });
};
/**
 * Custom React-Select's DropdownIndicator component to update the arrow icon.
 */ const $16a7d960140cfe88$var$DropdownIndicator = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5r4Ts.c).DropdownIndicator, {
        ...props,
        children: "\u25BE"
    });
};
/**
 * Maps locale values to their BCP 47 language tags where they differ.
 * e.g. WAC uses "br" for Brazilian Portuguese, but the correct lang attribute is "pt".
 */ const $16a7d960140cfe88$var$langOverrides = {
    br: 'pt'
};
/**
 * Custom React-Select's Option component to render lang attribute on non-English options.
 * WCAG 3.1.2: Language of Parts - Screen readers need lang attribute to pronounce non-English text correctly.
 */ const $16a7d960140cfe88$var$Option = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5r4Ts.c).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            lang: $16a7d960140cfe88$var$langOverrides[props.data.value] ?? props.data.value,
            children: children
        })
    });
/**
 * Styles for the LanguageSelector container div.
 */ const $16a7d960140cfe88$var$languageSelectorContainerStyle = null;
const $16a7d960140cfe88$export$ddd501dda1f62236 = ({ selectedLanguage: selectedLanguage = 'en', onLanguageChangeHandler: onLanguageChangeHandler, className: className, testId: testId })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const intl = (0, $8e22h.default)();
    const [isMouseOver, setMouseOver] = (0, $1oC0p.useState)(false);
    const elementID = 'language-dropdown';
    if (!onLanguageChangeHandler) onLanguageChangeHandler = (newLocale)=>{
        // check if there is already a locale in the path
        const { path: path } = (0, $hu7gH.parseRoute)(window.location);
        // exclude trailing slash in the case of the home page
        window.location.href = path.length ? `/${newLocale}/${path}` : `/${newLocale}`;
    };
    // TODO: Replace hardcoded color values with wacToken and ADS elevation tokens
    /* eslint-disable local/ensure-wac-token-usage */ const languageSelectStyle = {
        container: (provided)=>({
                ...provided,
                appearance: 'none',
                flexDirection: 'row',
                fontSize: '0.875rem;',
                textAlign: 'left'
            }),
        control: (provided, state)=>({
                ...provided,
                color: isDarkTheme ? isMouseOver ? (0, $kbpa7.wacToken)('color.neutral.dark1100') : (0, $kbpa7.wacToken)('color.neutral.light0') : isMouseOver ? '#172b4d' : '#42526e',
                cursor: isMouseOver ? 'pointer' : 'default',
                display: 'inline-flex',
                border: state.isFocused ? `2px solid #4c9aff` : '2px solid transparent'
            }),
        valueContainer: (provided)=>({
                ...provided,
                marginLeft: "var(--ds-space-050, 4px)",
                textDecorationLine: isMouseOver ? 'underline' : 'none'
            }),
        indicatorsContainer: (provided)=>({
                ...provided,
                marginLeft: "var(--ds-space-050, 4px)"
            }),
        dropdownIndicator: (provided)=>({
                ...provided,
                fontSize: '1.5rem',
                height: '40px'
            }),
        menu: (provided)=>({
                ...provided,
                marginTop: "var(--ds-space-050, 4px)",
                boxShadow: '0px 3px 5px 0px #091E4233',
                background: '#ffffff',
                borderRadius: "var(--ds-space-050, 4px)",
                width: '5.5rem'
            }),
        option: (provided, state)=>({
                ...provided,
                cursor: 'pointer',
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
                backgroundColor: state.isSelected ? '#b2d4ff' : state.isFocused ? '#ebecf0' : '#fafbfc',
                color: state.isSelected ? '#0065ff' : '#172b4d',
                outline: state.isFocused ? `2px solid ${(0, $kbpa7.wacToken)('color.primary.blue')}` : 'none',
                outlineOffset: '-2px',
                '&:hover': {
                    background: state.isSelected ? '#b2d4ff' : '#ebecf0'
                },
                '&:active': {
                    background: '#dfe1e5'
                }
            })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                    htmlFor: elementID,
                    children: intl.formatMessage({
                        defaultMessage: 'Language selector',
                        id: 'globalFooter.bottom.language-selector.label'
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c116y",
                    className
                ]),
                "data-testid": testId,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                    name: "global-footer-v2-language-selector-component",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                        inputId: elementID,
                        defaultValue: (0, $aKcYL.languages).find((language)=>language.value === selectedLanguage),
                        options: (0, $aKcYL.languages),
                        onChange: (selectedOption)=>{
                            if (selectedOption && selectedOption.value !== selectedLanguage) onLanguageChangeHandler?.(selectedOption.value);
                        },
                        unstyled: true,
                        // @ts-expect-error this is a rarely touched component with simplified typing, but is expected to work
                        isMouseOver: isMouseOver,
                        isDarkTheme: isDarkTheme,
                        onMenuClose: ()=>setMouseOver(false),
                        "aria-label": intl.formatMessage({
                            defaultMessage: 'Choose your language',
                            id: 'globalFooter.bottom.language-selector'
                        }),
                        components: {
                            Control: $16a7d960140cfe88$var$Control,
                            DropdownIndicator: $16a7d960140cfe88$var$DropdownIndicator,
                            Option: $16a7d960140cfe88$var$Option
                        },
                        styles: languageSelectStyle,
                        menuPlacement: "auto"
                    })
                })
            })
        ]
    });
};

});


//# sourceMappingURL=language-selector.7ebdd43c.js.map
